import i18n from "./index";
import {
  LOCALE_STORAGE_KEY,
  type AppLocale,
  localeToHtmlLang,
} from "./constants";
import { trackEvent } from "@/utils/analytics";

export function applyDocumentLang(locale: AppLocale): void {
  document.documentElement.lang = localeToHtmlLang(locale);
  document.documentElement.dataset.locale = locale;
}

export async function changeLocale(to: AppLocale, from: AppLocale): Promise<void> {
  if (to === from) return;
  await i18n.changeLanguage(to);
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, to);
  } catch {
    /* ignore */
  }
  applyDocumentLang(to);
  trackEvent("language_toggle", { from, to });
}
